/**
 * All possible user role values.
 * This should be kept in sync with backend/app/services/analytics_service.py USER_ROLES
 */
export const ALL_USER_ROLES = [
  'ADMIN',
  'USER',
  'VIEWER',
  'DEVELOPER',
  'TECHNICAL_ARCHITECT',
  'PRODUCT_OWNER',
  'BUSINESS_ANALYST',
] as const;

/**
 * Type for user role values
 */
export type UserRole = (typeof ALL_USER_ROLES)[number];

/**
 * Role display names for UI
 */
export const USER_ROLE_LABELS: Record<UserRole, string> = {
  ADMIN: 'Admin',
  USER: 'User',
  VIEWER: 'Viewer',
  DEVELOPER: 'Developer',
  TECHNICAL_ARCHITECT: 'Technical Architect',
  PRODUCT_OWNER: 'Product Owner',
  BUSINESS_ANALYST: 'Business Analyst',
};

/**
 * Helper to check if a value is a valid user role
 */
export function isValidUserRole(value: string): value is UserRole {
  return ALL_USER_ROLES.includes(value as UserRole);
}
